import { render, staticRenderFns } from "./csfeedback.vue?vue&type=template&id=3e766bcb&scoped=true&"
import script from "./csfeedback.vue?vue&type=script&lang=js&"
export * from "./csfeedback.vue?vue&type=script&lang=js&"
import style0 from "./csfeedback.vue?vue&type=style&index=0&id=3e766bcb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e766bcb",
  null
  
)

export default component.exports